import { Container, Row, Col } from "react-bootstrap";
import Image from "react-bootstrap/Image";
// import im_stchph from "../static/images/stch_phone.jpeg";
import im_stchbox from "../static/images/stch_box_open.jpeg";
import im_stchresults from "../static/images/STCH_WebPressureLinePlot.jpeg";
import im_stchgif from  "../static/images/a.gif";

import VTKScene from "./VTKScene";
import expertVTKJS from "../static/DEMO-Vel_Expert.vtkjs";
import exStitchVTKJS from "../static/images/exampleStitches_MC02.vtkjs"


import "../style/App.css";
import "../style/ReactBootstrapOverride.css";
import "../style/Home.css";

// #TODO - template

const STCH = () => {
  return (
    <div>
      <Container fluid className="gradient-wwd py-5 my-5">
        <Row className="px-5 mx-5">
          <Row className="col-white">
            <h1>STCH</h1>
          </Row>
          <Row>
            <Col>
              <p className="col-white">
                STCH is an all inclusive kit containing all the materials and
                equipment to construct and assess 20 simulated anastomoses.
              </p>
              <p className="col-white">
                Completed anastomoses are scanned, and proprietary CFI
                algorithms are used to provide a quantitative measure of the
                anastomotic narrowing, flow resistance and suture placement
                accuracy.
              </p>
            </Col>
            <Col>
              <Row>
                <Image
                  src={im_stchbox}
                  alt="im_stch_box"
                  fluid 
                  bsPrefix="cfi-images "
                ></Image>
              </Row>
            </Col>
          </Row>
        </Row>
      </Container>

      <Container fluid className="gradient-wwd py-5 my-5">
        <Row className="px-5 mx-5 ">
          <Row className="col-white">
            <h2 className="col-white">Stitch, score, critique, repeat...</h2>
          </Row>
          <Row>
              <p className="col-white">
                Each trainee has an individual, secure login to CFI servers
                where results are available as interactive 3D models and in a
                graphical format for comparison with movies of each anastomosis
                throughout the training series.
              </p>
          </Row>
              <Row>
            <Col>
                <Image
                  src={im_stchgif}
                  alt="im_stch_uct"
                  fluid
                  bsPrefix="cfi-images-small "
                ></Image>
            </Col>
            {/* <Col>
            <VTKScene url={expertVTKJS} showButtons={false} viewWidth={300}></VTKScene>
            </Col> */}
            <Col>
            <VTKScene url={exStitchVTKJS} showButtons={false}  viewWidth={300} key='exampleSTITCHES'></VTKScene>
            </Col>
              </Row>
        </Row>
      </Container>

      <Container fluid className="gradient-wwd py-5 my-5">
        <Row className="px-5 mx-5 ">
          <Row className="col-white">
            <h2 className="col-white">Removing the burden of training</h2>
          </Row>
          <Row>
            <Col>
              <p className="col-white">
                We facilitate all feedback and guide all feedback seesions with 
                simple clear progress reports so that supervisors may concentrate
                on training and not administration..
              </p>
              {/* <p className="col-white">
                This allows trainees to identify areas for improvement and
                refine their skills more rapidly. With our comprehensive data
                analytics, supervisors can track progress, customise training
                programs and tailor feedback to individual needs.
              </p> */}
            </Col>
            <Col>
              <Row>
                <Image
                  src={im_stchresults}
                  alt="im_stch_results"
                  fluid
                  bsPrefix="cfi-images "
                ></Image>
              </Row>
            </Col>
          </Row>
        </Row>
      </Container>
    </div>
  );
};

export default STCH;
